import { IconName } from '@frontend/icons';
import { theme } from '@frontend/theme';

export interface ForYouFilterType {
  id: string;
  displayName: string;
  iconName: IconName;
  component: ({ closePopOver }: { closePopOver: () => void }) => JSX.Element;
  hide: boolean;
}

export interface PaletteColorType {
  color: string;
  backgroundColor: string;
  textColor: string;
}

export const AI_RECEPTIONIST_STATE_BACKGROUND_GRADIENT = 'linear-gradient(#DDEDFD, #E0F9F9)';

export const PaletteColors: Record<string, PaletteColorType> = {
  neutral: {
    color: 'neutral',
    textColor: theme.colors.neutral50,
    backgroundColor: theme.colors.neutral5,
  },
  success: {
    color: 'success',
    textColor: theme.colors.success50,
    backgroundColor: theme.colors.success5,
  },
  seaweed: {
    color: 'seaweed',
    textColor: theme.colors.secondary.seaweed50,
    backgroundColor: theme.colors.secondary.seaweed5,
  },
  skyBlueGradient: {
    color: 'skyBlueGradient',
    textColor: theme.colors.neutral90,
    backgroundColor: AI_RECEPTIONIST_STATE_BACKGROUND_GRADIENT,
  },
  primary: {
    color: 'primary',
    textColor: theme.colors.primary50,
    backgroundColor: theme.colors.primary5,
  },
  indigo: {
    color: 'indigo',
    textColor: theme.colors.indigo50,
    backgroundColor: theme.colors.indigo5,
  },
  eggplant: {
    color: 'eggplant',
    textColor: theme.colors.secondary.eggplant50,
    backgroundColor: theme.colors.secondary.eggplant5,
  },
  rose: {
    color: 'rose',
    textColor: theme.colors.rose50,
    backgroundColor: theme.colors.rose5,
  },
  critical: {
    color: 'critical',
    textColor: theme.colors.critical50,
    backgroundColor: theme.colors.critical5,
  },
  tangerine: {
    color: 'tangerine',
    textColor: theme.colors.tangerine40,
    backgroundColor: theme.colors.tangerine5,
  },
  warning: {
    color: 'warning',
    textColor: theme.colors.warning30,
    backgroundColor: theme.colors.warning5,
  },
  gradient: {
    color: 'gradient',
    textColor: theme.colors.indigo70,
    backgroundColor: 'linear-gradient(92.94deg, #DCEBFE80 48.5%, #F7D8FF80 100%)',
  },
};

export const PaletteColorValues = Object.values(PaletteColors);
